export default "__VITE_ASSET__DpeTqKLJ__"